import { render, staticRenderFns } from "./MessagePreviewSheet.vue?vue&type=template&id=2a84297f&scoped=true"
import script from "./MessagePreviewSheet.vue?vue&type=script&lang=js"
export * from "./MessagePreviewSheet.vue?vue&type=script&lang=js"
import style0 from "./MessagePreviewSheet.vue?vue&type=style&index=0&id=2a84297f&prod&scoped=true&lang=css"
import style1 from "./MessagePreviewSheet.vue?vue&type=style&index=1&id=2a84297f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84297f",
  null
  
)

export default component.exports